import { render, staticRenderFns } from "./PaxelpreneurCreate.vue?vue&type=template&id=45d9682e&"
import script from "./PaxelpreneurCreate.vue?vue&type=script&lang=js&"
export * from "./PaxelpreneurCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports